<template lang="html">

<div>
    <v-header backTo="Login profissional">
        <router-link  :to="{name: 'client-login'}" class="linkLogin">
          Sou empresa
        </router-link>
    </v-header>
  <v-page class="page-login" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
    <div class="autoLogin">
      <v-login class="card-login">
        <div class="center">
          <div class="loginLeft">
            <div class="companylogin ">
              <p>P</p>
              <p>R</p>
              <p>O</p>
              <p>F</p>
              <p>I</p>
              <p>S</p>
              <p>S</p>
              <p>I</p>
              <p>O</p>
              <p>N</p>
              <p>A</p>
              <p>L</p>
            </div>
            <div>
              <!-- Se houver algo aqui, você pode adicionar -->
            </div>
            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
          <div class="loginRight">
            <form @submit.prevent="login()">
              <v-text tag="h2" class="titleLoginProfisional">Acesse sua conta</v-text>
              <v-input type="email" id="signin-email" v-model="email">E-mail</v-input>
              <v-input type="password" id="signin-password" v-model="password">Senha</v-input>
              <v-button type="submit" class="block mt-2" style="background-color: #458B23; color:white">Login</v-button>

              <div class="helpers">
                <div class="dataRadio">
                  <v-input type="checkbox" class="inputRadioProfisional" id="" v-model=" remember" />Lembrar os meus dados
                </div>
                <small class="d-flex justify-content-between">
                  <v-link class="profForgot" :to="{ name: profile + '-recover-pass' }"><p class="registeHere">Esqueceu a senha?</p></v-link>
                </small>
              </div>
              <!-- <div class="register">
                <p>Não possuo uma conta</p>
                <v-link class="profForgot" :to="{name: 'vibbrant-register'}">Cadastre-se aqui</v-link>
              </div> -->
            </form>
          </div>
        </div>
      </v-login>
    </div>
  </v-page>
  </div>

</template>


<script>

import apiClient from '@/api/client';
import apiVibbrante from '@/api/vibbrante';
import { profile } from '../../configs/js/config';

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      email: '',
      password: '',
      remember: false,
      today_date: new Date(),
      img_url: require('../../assets/photoPeople/Sarah-designer.png'),
      img_background_url: require('../../assets/background/fundo-verde.svg'),
         isLoading: false,
    };
  },
  mounted() {
    if (localStorage.remember) {
      this.email = localStorage.email;
      this.password = localStorage.password;
      this.remember = true;

       setTimeout(() => {
      this.isLoading = true;
    }, 5);

    }
  },
  watch: {
    email(newName) {
      localStorage.email = newName;
    },
    password(newName) {
      localStorage.password = newName;
    },
    remember(newName) {
      localStorage.remember = newName;
    },
  },
  methods: {

    login(email, password) {

      if (this.profile === 'analyst' ||this.profile === 'designer' ||this.profile === 'manager' || this.profile === 'programmer' ) {
        apiClient
          .sign_in(this.email, this.password)
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('loginClient', response);
              if (
                (this.today_date.getMonth() === 11 && this.today_date.getDate() >= 15) ||
                (this.today_date.getMonth() === 0 && this.today_date.getDate() <= 5)
              ) {
                this.$router.push({
                  name: 'client-dashboard',
                  query: { campaing: 'recesso_2022' },
                });
              } else {
                this.$router.push({ name: 'client-dashboard' });
              }
            }
          })
          .catch((e) => {
            this.$notify(
              'Opa! Ocorreu um erro não esperado. Recarregue a página e tente novamanete.',
              'error'
            );
          });
      } else {
        apiVibbrante
          .sign_in(this.email, this.password)
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('loginVibbrante', response);
              if (
                (this.today_date.getMonth() === 11 && this.today_date.getDate() >= 15) ||
                (this.today_date.getMonth() === 0 && this.today_date.getDate() <= 5)
              ) {
                this.$router.push({
                  name: 'vibbrant-dashboard',
                  query: { campaing: 'recesso_2022' },
                });
              } else {
                this.$router.push({ name: 'vibbrant-dashboard' });
              }
            }
          })
          .catch((e) => {
            this.$notify(
              'Opa! Ocorreu um erro não esperado. Recarregue a página e tente novamanete.',
              'error'
            );
          });
      }
      if (this.remember === true) {
        localStorage.email = this.email;
        localStorage.password = this.password;
        localStorage.remember = true;
      } else {
        localStorage.removeItem('email');
        localStorage.removeItem('password');
        localStorage.removeItem('remember');
      }
    },
  },
};
</script>

<style lang="scss">
 .linkLogin{
      color: white !important;
 }
  .linkLogin:hover{
    color:#458b23 !important;
      text-decoration: none;
  }
.page-login {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: calc(100vh - 60px) !important;

  position: relative;

  &:not(.company) {
    &:before {
        content: '';
        background-image: url('../../assets/background/fundo-verde.svg');
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%; /* Para garantir que a imagem fique atrás do conteúdo */
    }
  }



  .autoLogin {
    width: 75%;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .card-login {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    justify-content: center;

    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
      display: flex;

      align-items: center;
      padding: 2rem 2rem 0 0;

       @include media-breakpoint-down(md) {
         padding: 2rem ;
      }
    }
    .loginLeft {
      display: flex;

      height: 100%;
      width: 60%;
      align-items:flex-end;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .companylogin {
      background-color: #458b23;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      max-height: 100%;
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 16px;
      overflow: hidden;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .loginRight {
      width: 40%;
       @include media-breakpoint-down(md) {
        width: 100%;
      }
    }

    .photo {
      display: block;
      height: 500px;
      margin-top: 6px;
    }

    .logo {
      height: 60px;
      text-align: center;
      margin: 0 0 30px 0;
    }

    .titleLoginProfisional {
      font-size: 45px;
      font-weight: bold;
      margin-bottom: 40px;
      text-align: center;
      @include media-breakpoint-down(md) {
         font-size: 35px;
      }
    }
    .dataRadio {
      display: flex;

      align-items: center;
    }
    .inputRadioProfisional {
      margin: 0 !important;
    }
    .helpers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
      }
    }
    .register {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 20px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
        text-align: center;
        gap:0;
        p{
          margin: 0;
        }
      }
    }

    .profForgot {
      color: #458b23;
    }
  }
 footer.page-footer {
    color: white;
    height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/loginProfessional.vue